import { lazy, Suspense } from 'react';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';

const LazyFlexStorageCounter = lazy(() =>
  import('./flex-storage-counter').then((m) => ({ default: m.FlexStorageCounter })),
);

/** The Storage chip for a page header. It shows on Flex only. */
export function StorageCounterSlot() {
  const { account } = useAuth();
  if (!isFlexPlan(account)) return null;

  return (
    <Suspense fallback={null}>
      <LazyFlexStorageCounter />
    </Suspense>
  );
}
